import React, { forwardRef} from 'react'
import PreviousSearch from './PreviousSearch'
import RecipeCard from './RecipeCard';
import ReactPaginate from 'react-paginate';

const HomeBody = ({search, setSearch, recipes, handlePageClick, totalPage}, ref) => {

  return (
    <div ref={ref} style={{ paddingTop: '60px' }}>
      <PreviousSearch search={search} setSearch={setSearch} />
      <div className="recipes-container">
        {recipes.map((recipe, index) => (
          <RecipeCard key={index} recipe={recipe} />
        ))}
      </div>
      {recipes.length === 0 && (
        <div className='no-recipe'>There are no recipes named "{search}"</div>
      )}
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        previousLabel="<"
        pageRangeDisplayed={3}
        renderOnZeroPageCount={null}
        containerClassName='pagination'
        pageLinkClassName='page-num'
        previousLinkClassName='page-num'
        nextLinkClassName='page-num'
        activeClassName='active'
        onPageChange={handlePageClick}
        pageCount={totalPage}
      />
    </div>
  )
}

export default forwardRef(HomeBody);
